module.exports = __webpack_public_path__ + "media/images/how-img-1440-b4d01d8b9d603d0c5d8206147aae6e46.png";